export default {
    rootUrl: "",
    baseUrl: "",
    loadings: ([] as string[]),
}
